module.exports = __webpack_public_path__ + "fonts/iconfont.120773a8.woff";